import { Component, Inject, OnInit } from '@angular/core';
import { NB_DIALOG_CONFIG, NbDialogRef } from '@nebular/theme';
import { DashboardFacade } from '../../../facade/dashboard.facade';

@Component({
  selector: 'morva-import-dashboard-activation-modal',
  templateUrl: './import-dashboard-activation-modal.component.html',
  styleUrl: './import-dashboard-activation-modal.component.scss',
})
export class ImportDashboardActivationModalComponent implements OnInit {

  title = 'فعال‌سازی داشبورد';
  workspaceId: string;
  file: File;
  connectionType: string = 'withData';

  connectionTypes = [
    { name: 'بله، با انتخاب منبع داده', value: 'withData' },
    { name: 'خیر، فقط ساختار داشبورد', value: 'withoutData' },
  ];

  constructor(
    private dialogRef: NbDialogRef<string>,
    private dashboardFacade: DashboardFacade,
    @Inject(NB_DIALOG_CONFIG) private config: any
  ) {}
  
  ngOnInit(): void {

  }

  continue(): void {
    if (!this.workspaceId || !this.file) {
      return;
    }
  
    if (this.connectionType === 'withData') {
      this.dashboardFacade.startImportWithDatasource(
        this.workspaceId,
        this.file
      );
    }
  
    if (this.connectionType === 'withoutData') {
      this.dashboardFacade.importWithoutDatasource(
        this.workspaceId,
        this.file
      );
    }
  
    this.dialogRef.close();
  }
  

  closeDialog(): void {
    this.dialogRef.close();
  }
}